import { createContext, useContext, useState } from "react";

const CopilotContext = createContext(null);

export function CopilotProvider({ children }) {
  const [activeEntity, setActiveEntity] = useState(null); // { id, type, name }
  return (
    <CopilotContext.Provider value={{ activeEntity, setActiveEntity }}>
      {children}
    </CopilotContext.Provider>
  );
}

export function useCopilot() {
  return useContext(CopilotContext) || { activeEntity: null, setActiveEntity: () => {} };
}
